import { useMemo } from 'react';
import { buildFilterOverlayLayers } from '@/lib/videoFilterOverlays';
import { normalizeClipFilters } from '@/lib/videoFilters';

/** Stacked gradient overlays on top of video/image (alpha compositing). */
export function VideoFilterOverlayStack({ filters, className = '' }) {
  const specs = useMemo(() => normalizeClipFilters(filters), [filters]);
  const layers = useMemo(() => buildFilterOverlayLayers(specs), [specs]);
  if (!layers.length) return null;
  return (
    <div
      className={`pointer-events-none absolute inset-0 z-[10] overflow-hidden ${className}`.trim()}
      aria-hidden
    >
      {layers.map((layer) => (
        <div key={layer.id} className="absolute inset-0" style={layer.style} />
      ))}
    </div>
  );
}
